module.exports = __webpack_public_path__ + "static/media/picto-magnify-white.2c51b816.svg";